import PropTypes from 'prop-types';

import WithLink from '../Linkify';
import { StyledCallCenterNote } from './styledComponents';

const NoteComponent = ({ note }) => {
  if (!note) return null;
  return (
    <StyledCallCenterNote>
      <WithLink>{note}</WithLink>
    </StyledCallCenterNote>
  );
};

NoteComponent.defaultProps = {
  note: null,
};

NoteComponent.propTypes = {
  note: PropTypes.string,
};

export default NoteComponent;
